/* ==========================================================
   ROTATION.NO — QUICK STATS
   Data + render logic. Load once via asset_url (cacheable).

   ADD A NEW SHOE: add an entry to SHOE_DATA below. The key is the
   lowercase substring matched against the product title (keep keys
   specific enough to avoid collisions, e.g. "bondi 8 ts" vs "bondi 8").
   ========================================================== */

(function () {
  var SHOE_DATA = {
    "hurricane 25": {
      brand: "Saucony", model: "Hurricane 25",
      pronation: 88, cushion: 20,
      features: ["Maks demping", "Stabil", "Myk"],
      weightValue: "283 g", weightNote: "herre — dame: 249 g",
      bestFor: ["Daglig trening", "Restitusjon & Avslapning", "Gåturer"],
      bestForPrimary: "Restitusjon & Avslapning",
      stack: 82, drop: 43 // 6 mm
    },
    "hurricane 26": {
      brand: "Saucony", model: "Hurricane 26",
      pronation: 70, cushion: 26,
      features: ["Lett", "Sprek", "Stabil"],
      weightValue: "262 g", weightNote: "herre — dame: 232 g",
      bestFor: ["Daglig trening", "Langkjøring", "Restitusjon & Avslapning"],
      bestForPrimary: "Daglig trening",
      stack: 90, drop: 43 // 6 mm
    },
    "guide 19": {
      brand: "Saucony", model: "Guide 19",
      pronation: 92, cushion: 46,
      features: ["Komfortabel", "Allsidig", "Stabil"],
      weightValue: "275 g", weightNote: "herre — dame: 252 g",
      bestFor: ["Daglig trening", "Gåturer", "Fotturer og trekking"],
      bestForPrimary: "Daglig trening",
      stack: 66, drop: 43 // 6 mm
    },
    "azura": {
      brand: "Saucony", model: "Endorphin Azura",
      pronation: 12, cushion: 76,
      features: ["Rask", "Allsidig", "Sprek"],
      weightValue: "240 g", weightNote: "herre — dame: 212 g",
      bestFor: ["Tempo & intervalltrening", "Daglig trening", "Konkurranse"],
      bestForPrimary: "Tempo & intervalltrening",
      stack: 78, drop: 57 // 8 mm
    },
    "endorphin speed 5": {
      brand: "Saucony", model: "Endorphin Speed 5",
      pronation: 10, cushion: 68,
      features: ["Rask", "Lett", "Sprek"],
      weightValue: "244 g", weightNote: "herre — dame: 213 g",
      bestFor: ["Tempo & intervalltrening", "Konkurranse", "Baneløp"],
      bestForPrimary: "Tempo & intervalltrening",
      stack: 58, drop: 57 // 8 mm
    },
    "kawana 3": {
      brand: "Hoka", model: "Kawana 3",
      pronation: 42, cushion: 62,
      features: ["Solid", "Allsidig", "Treningsvennlig"],
      weightValue: "326 g", weightNote: "unisex",
      bestFor: ["Fitness", "Daglig trening", "Gåturer"],
      bestForPrimary: "Fitness",
      stack: 68, drop: 36 // 5 mm
    },
    "clifton 10": {
      brand: "Hoka", model: "Clifton 10",
      pronation: 36, cushion: 24,
      features: ["Myk", "Komfortabel", "Allsidig"],
      weightValue: "278 g", weightNote: "herre — dame: 227 g",
      bestFor: ["Daglig trening", "Restitusjon & Avslapning", "Gåturer"],
      bestForPrimary: "Daglig trening",
      stack: 92, drop: 57 // 8 mm
    },
    "clifton 11": {
      brand: "Hoka", model: "Clifton 11",
      pronation: 34, cushion: 26,
      features: ["Myk", "Pålitelig", "Komfortabel"],
      weightValue: "283 g", weightNote: "herre — dame: 232 g",
      bestFor: ["Daglig trening", "Restitusjon & Avslapning", "Gåturer"],
      bestForPrimary: "Restitusjon & Avslapning",
      stack: 92, drop: 57 // 8 mm
    },
    "clifton pro": {
      brand: "Hoka", model: "Clifton Pro",
      pronation: 30, cushion: 54,
      features: ["Sprek", "Responsiv", "Allsidig"],
      weightValue: "296 g", weightNote: "herre — dame: 242 g",
      bestFor: ["Daglig trening", "Tempo & intervalltrening", "Konkurranse"],
      bestForPrimary: "Daglig trening",
      stack: 92, drop: 57 // 8 mm
    },
    "bondi 9": {
      brand: "Hoka", model: "Bondi 9",
      pronation: 18, cushion: 32,
      features: ["Maks demping", "Myk", "Stabil"],
      weightValue: "296 g", weightNote: "herre — dame: 236 g",
      bestFor: ["Restitusjon & Avslapning", "Gåturer", "Daglig trening"],
      bestForPrimary: "Restitusjon & Avslapning",
      stack: 96, drop: 36 // 5 mm
    },
    "bondi 8 ts": {
      brand: "Hoka", model: "Bondi 8 TS",
      pronation: 20, cushion: 28,
      features: ["Maks demping", "Livsstil", "Myk"],
      weightValue: "311 g", weightNote: "herre — dame: 252 g",
      bestFor: ["Gåturer", "Restitusjon & Avslapning", "Daglig trening"],
      bestForPrimary: "Gåturer",
      stack: 86, drop: 29 // 4 mm
    },
    "mafate speed 2": {
      brand: "Hoka", model: "Mafate Speed 2",
      pronation: 38, cushion: 58,
      features: ["Beskyttende", "Grov terreng", "Stabil"],
      weightValue: "329 g", weightNote: "unisex",
      bestFor: ["Terrengløp", "Fotturer og trekking", "Konkurranse"],
      bestForPrimary: "Terrengløp",
      stack: 78, drop: 29 // 4 mm
    },
    "bondi 7": {
      brand: "Hoka", model: "Bondi 7",
      pronation: 16, cushion: 20,
      features: ["Maks demping", "Myk", "Stabil"],
      weightValue: "303 g", weightNote: "herre — dame: 252 g",
      bestFor: ["Restitusjon & Avslapning", "Gåturer", "Daglig trening"],
      bestForPrimary: "Restitusjon & Avslapning",
      stack: 74, drop: 29 // 4 mm
    },
    "kaha 2": {
      brand: "Hoka", model: "Kaha 2 GTX",
      pronation: 14, cushion: 44,
      features: ["Vanntett", "Beskyttende", "Stabil"],
      weightValue: "476 g", weightNote: "herre — dame: 442 g",
      bestFor: ["Fotturer og trekking", "Gåturer"],
      bestForPrimary: "Fotturer og trekking",
      stack: 88, drop: 43 // 6 mm
    },
    "kaha 3": {
      brand: "Hoka", model: "Kaha 3 GTX",
      pronation: 14, cushion: 50,
      features: ["Vanntett (GORE-TEX)", "Maks demping", "Robust"],
      weightValue: "567 g", weightNote: "herre — dame: 476 g",
      bestFor: ["Fotturer og trekking", "Gåturer"],
      bestForPrimary: "Fotturer og trekking",
      stack: 92, drop: 57 // 8 mm
    }
  };

  function findMatch(title) {
    var t = (title || "").toLowerCase();
    var keys = Object.keys(SHOE_DATA).sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < keys.length; i++) {
      if (t.indexOf(keys[i]) !== -1) return SHOE_DATA[keys[i]];
    }
    return null;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderMeter(pct, segCount, leftLabel, midLabel, rightLabel) {
    var filled = Math.max(1, Math.min(segCount, Math.round((pct / 100) * segCount)));
    var segs = "";
    for (var i = 0; i < segCount; i++) {
      segs += '<div class="rqs-seg' + (i < filled ? " is-filled" : "") + '"></div>';
    }
    var captions = midLabel
      ? "<span>" + leftLabel + "</span><span>" + midLabel + "</span><span>" + rightLabel + "</span>"
      : "<span>" + leftLabel + "</span><span>" + rightLabel + "</span>";
    return (
      '<div class="rqs-meter">' + segs + "</div>" +
      '<div class="rqs-meter-caption">' + captions + "</div>"
    );
  }

  function renderPills(list, primary) {
    return (
      '<div class="rqs-pills">' +
      list
        .map(function (item) {
          var cls = item === primary ? "rqs-pill is-primary" : "rqs-pill";
          return '<span class="' + cls + '">' + escapeHtml(item) + "</span>";
        })
        .join("") +
      "</div>"
    );
  }

  function render(root, shoe) {
    var html =
      '<div class="rqs-card">' +
        '<div class="rqs-head">' +
          '<p class="rqs-eyebrow">Quick Stats</p>' +
          '<span class="rqs-brandtag">' + escapeHtml(shoe.brand) + "</span>" +
        "</div>" +
        '<p class="rqs-model">' + escapeHtml(shoe.model) + "</p>" +
        '<p class="rqs-tagline">Vurdert av våre løpeeksperter</p>' +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Pronasjonsstøtte</span>' +
          renderMeter(shoe.pronation, 5, "Nøytral", null, "Stabilitet") +
        "</div>" +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Demping</span>' +
          renderMeter(shoe.cushion, 5, "Myk", "Balansert", "Fast") +
        "</div>" +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Viktigste egenskaper</span>' +
          renderPills(shoe.features, shoe.features[0]) +
        "</div>" +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Vekt</span>' +
          '<div class="rqs-stat">' +
            '<span class="rqs-stat-value">' + escapeHtml(shoe.weightValue) + "</span>" +
            '<span class="rqs-stat-unit">' + escapeHtml(shoe.weightNote) + "</span>" +
          "</div>" +
        "</div>" +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Best til</span>' +
          renderPills(shoe.bestFor, shoe.bestForPrimary) +
        "</div>" +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Mellomsålehøyde</span>' +
          renderMeter(shoe.stack, 5, "Høy", "Middels", "Lav") +
        "</div>" +

        '<div class="rqs-row">' +
          '<span class="rqs-label">Hældropp</span>' +
          renderMeter(shoe.drop, 5, "0–4 mm", "5–8 mm", "9–14 mm") +
        "</div>" +

      "</div>";

    root.innerHTML = html;
  }

  function init() {
    var root = document.querySelector(".rqs-root");
    if (!root) return;
    var shoe = findMatch(root.getAttribute("data-rqs-title"));
    if (!shoe) return; // product not in list — render nothing
    render(root, shoe);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();